import React, { ReactNode } from 'react';
import { containers } from '@ecosystem/newron-design-system';

const { Tile } = containers;

interface WithTileProps {
  children: ReactNode;
  testId: string;
  isLoading?: boolean;
}

export const WithTile: React.FC<WithTileProps> = ({ children, testId, isLoading = false }) => {
  return (
    <Tile testId={testId} isLoading={isLoading}>
      {children}
    </Tile>
  );
};
